import { AffiliateApi } from "@/api/affiliates";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetPayouts = () => {
  const { data, isPending } = useQuery({
    queryKey: [QueryKey.PAYOUTS],
    queryFn: () => AffiliateApi.getPayouts(),
  });

  return {
    payouts: data,
    isPayoutsLoading: isPending,
  };
};
